export function EmptyState({
  icon = "📭",
  title = "Nothing here yet",
  description = "",
}: {
  icon?: string;
  title?: string;
  description?: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <span className="text-4xl mb-3">{icon}</span>
      <h3 className="text-body font-medium text-app-text">{title}</h3>
      {description && (
        <p className="text-info text-app-text-muted mt-1 max-w-xs">{description}</p>
      )}
    </div>
  );
}
